define( function() {
	return ( /^margin/ );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/css/var/rmargin.js
// module id = 334
// module chunks = 1